import { Box, Grid, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Navbar from "../../../components/Navbar";
import { useState, useMemo, useEffect } from "react";
import LinearStepper from "./components/Stepper";
import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";
import StepThree from "./components/StepThree";
import Review from "./components/Review";
import StepFour from "./components/StepFour";
import { useLocation } from "react-router-dom";
import Gobutton from "../../../components/Gobutton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const defaultAsset = {
  Title: "",
  Heading: "",
  AiFeatures: [],
  Features: [],
  Children: [],
  Image: "",
  desc: "",
  Type: "app",
  appUrl: "",
  htmlUrl: "",
  tulipLibrary: "",
  flow: false,
  editorUrl: "",
  contentUrl: "",
  img: "",
  video: "",
  private: "",
  status: "review",
};

const assetsSteps = [
  "Create Asset Card",
  "Define Asset",
  "Add Links",
  "Add AI Features",
];
const editAssetsSteps = [
  "Edit Asset Card",
  "Define Asset",
  "Edit Links",
  "Edit AI Features",
];

export default function AssetsForm() {
  const [asset, setAsset] = useState(defaultAsset);
  const [activeStep, setActiveStep] = useState(0);
  const location = useLocation();

  // pull editableAsset from navigation state
  const { editableAsset } = location.state || {};

  // decide steps depending on mode
  const steps = useMemo(
    () => (editableAsset ? editAssetsSteps : assetsSteps),
    [editableAsset]
  );

  const resetAsset = () => {
    setActiveStep(0);
    setAsset(defaultAsset);
  };

  // set asset when editing
  useEffect(() => {
    if (editableAsset && editableAsset.id) {
      setAsset(editableAsset);
    }
  }, [editableAsset]);

  // reset only when creating (no editableAsset)
  useEffect(() => {
    if (!editableAsset) {
      resetAsset();
    }
  }, [location.pathname, editableAsset]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Navbar />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
        className="w-full px-3 md:w-[80%]"
      >

        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h5" sx={{ alignSelf: "start" }}>
          {!editableAsset ? "Create vTEC Asset" : "Edit vTEC Asset"}
        </Typography>

          <Gobutton
            text={"Back to List"}
            endIcon={<ArrowForwardIcon />}
            url={{ type: "assets", url: "/assets" }}
          />
        </Grid>

        <LinearStepper
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          asset={asset}
          resetAsset={resetAsset}
          steps={steps}
        >
          <Paper
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              padding: 4,
              margin: 2,
              gap: 2,
            }}
            elevation={4}
            margin={10}
          >
            {activeStep === 0 && <StepOne asset={asset} setAsset={setAsset} />}
            {activeStep === 1 && <StepTwo asset={asset} setAsset={setAsset} />}
            {activeStep === 2 && (
              <StepThree asset={asset} setAsset={setAsset} />
            )}
            {activeStep === 3 && <StepFour asset={asset} setAsset={setAsset} />}
            {activeStep === 4 && <Review asset={asset} setAsset={setAsset} />}
          </Paper>
        </LinearStepper>
      </Box>
    </Box>
  );
}
